/**
 * Custom error classes for content service operations
 */

export class ContentError extends Error {
  constructor(
    message: string,
    public cause?: unknown,
  ) {
    super(message);
    this.name = "ContentError";
  }
}

export class ContentFetchError extends ContentError {
  constructor(
    message: string,
    cause?: unknown,
    /** HTTP status of the failed response, when one was received. */
    public status?: number,
  ) {
    super(message, cause);
    this.name = "ContentFetchError";
  }
}

export class ContentValidationError extends ContentError {
  constructor(
    message: string,
    public validationErrors?: unknown,
  ) {
    super(message);
    this.name = "ContentValidationError";
  }
}

export class ContentNotFoundError extends ContentError {
  constructor(message: string) {
    super(message);
    this.name = "ContentNotFoundError";
  }
}
